import { Typography } from "@suraasa/placebo-ui"
import suraasaLogo from "assets/suraasaGreyLogo.webp"
import clsx from "clsx"
import { useGlobalContext } from "global/Context/context"
import { useParams } from "react-router-dom"

const AboutThisReport = ({
  id,
  className,
}: {
  id: string
  className?: string
}) => {
  const { attemptId } = useParams()
  const { authInfo } = useGlobalContext()

  return (
    <div>
      <div
        id={id}
        className={clsx(
          "rounded-xl border border-surface-200 bg-white p-4",
          className
        )}
        style={{
          boxShadow: "0px 1px 2px 0px #0F172A0D, 0px 4px 8px 0px #0F172A0D",
        }}
      >
        <Typography variant={"title3"} className="mb-2.5">
          About This Report
        </Typography>
        <Typography variant={"body"} className="text-onSurface-700">
          <div className="font-bold">What is Proctoring?</div>
          <br />
          <div>
            Proctoring is a monitoring system used to ensure the integrity and
            fairness of assessments conducted remotely. It monitors candidate
            activity during the assessment to verify identity and prevent unfair
            practices.
          </div>
          <br />
          <div>
            During the assessment, automated proctoring systems observe your
            device’s activity and camera input. Specific events are recorded
            based on predefined rules and thresholds, and are included in this
            proctoring report.
          </div>
          <br />
          <div>
            This report summarizes proctoring events recorded during the
            assessment and presents detected activities and supporting evidence
            that form the basis for evaluating assessment integrity.
          </div>
        </Typography>
      </div>
      <div className="flex flex-col items-center p-4 md:max-w-2xl md:items-start">
        <Typography
          variant={"smallBody"}
          className="text-center text-onSurface-500 md:text-left"
        >
          If you believe any information in this report requires clarification
          or review, please reach out to us at{" "}
          <a
            className="text-highlight-500 hover:underline"
            href={`mailto:care@suraasa.com?subject=Query regarding CPAT Proctoring Report&body=Hi Suraasa Team,%0D%0A%0D%0AI have a query regarding my CPAT Proctoring Report. Please find the details below:%0D%0A%0D%0AAttempt ID: ${attemptId} %0D%0AMy email is: ${encodeURIComponent(
              authInfo?.user?.email ?? ""
            )}%0D%0A%0D%0AThank you!`}
          >
            care@suraasa.com
          </a>
        </Typography>
        <img src={suraasaLogo} alt="Suraasa" className="mt-6 h-3" />
      </div>
    </div>
  )
}

export default AboutThisReport
